import { createFileRoute, redirect } from '@tanstack/react-router'
import { CouponCreatePage } from '@/pages/Coupons/CouponCreatePage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/coupons_/create')({
  component: CouponCreatePage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/coupons')) {
      throw redirect({ to: '/' })
    }
  },
})
